/**
 * /devhub/embedding-atlas — Local Embedding Atlas of the workspace RAG.
 * REQ-001.91 DevHub UI rebuild · Phase 5 (AI features).
 *
 * Live panel: EmbeddingAtlasPanel renders `data/runtime/embedding_atlas.json`
 * (built by scripts/embedding_atlas_project.py, UMAP-projected from the
 * 768-dim Granite embeddings in data/local_dev/local_dev.sqlite::knowledge_chunks).
 * 100% Carbon Charts (g100); each row is clickable for a Send-to-AI affordance.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */

import { createFileRoute } from '@tanstack/react-router';
import { EmbeddingAtlasPanel } from '../features/control-plane/EmbeddingAtlasPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/embedding-atlas')({
  component: EmbeddingAtlasPage,
});

function EmbeddingAtlasPage() {
  return (
    <DevHubPanelPage
      title="Embedding Atlas"
      subtitle="2D UMAP projection of every knowledge_chunks row in the local RAG (Granite 768-dim → cosine). Click a point for the row's complete info + Send-to-AI. Local-only — never a paid adapter."
      status={{ label: 'live', live: true }}
    >
      <EmbeddingAtlasPanel />
    </DevHubPanelPage>
  );
}
